import React, { useState } from "react";
import './trivia.css'
import 'animate.css'

const Card = ({ number, win, title }) => {
  const [size, setSize] = useState(0);

  const getSize = (url) => {
    const img = new Image();
    img.onload = () => {
      setSize(img.width / img.height);
    };
    img.src = url;
  };

  const Imagen = () => {
    getSize(`../../../images/${number}.jpg`);
    if (size > 1) {
      if (win) {
        return (
          <div className={`bg h`}>
            <img className="animate__animated animate__flipInX"
              src={`../../../thumbs/${number}.jpg`}
              alt="imagen"
            />
            <p>{number}</p>
            <span className="question-title">{title}</span>
          </div>
        );
      } else {
        return <div className={`bg h relleno`}><p>{number}</p></div>;
      }
    } else {
      if (win) {
        return (
          <div className={`bg v`}>
            <img className="animate__animated animate__flipInY"
              src={`../../../thumbs/${number}.jpg`}
              alt="imagen"
            />
            <p>{number}</p>
            <span className="question-title">{title}</span>
          </div>
        );
      } else {
        return <div className={`bg v relleno`}><p>{number}</p></div>;
      }
    }
  };


  return (
    <>
      {Imagen(number)}
    </>
  );
};

export default Card;
